import type { AppRoute } from "@/lib/routing";
import { JobsPage } from "./JobsPage";
import { SettingsPage } from "./SettingsPage";

// Owner: B1 (frontend foundation).
export const routes: AppRoute[] = [
  {
    path: "/settings",
    element: <SettingsPage />,
    handle: {
      title: "Settings",
      keywords: [
        "ship to",
        "address",
        "currency",
        "theme",
        "balance",
        "tolerance",
        "calibration",
        "calendar",
        "schedules",
        "preferences",
      ],
    },
  },
  {
    path: "/jobs",
    element: <JobsPage />,
    handle: { title: "Jobs", keywords: ["background", "worker", "sync", "queue", "tasks"] },
  },
];
